// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"800":"6bc7493a","802":"6b232a99"}[chunkId] + ".chunk.js";
};